import React from 'react';
import { Pane, Strong, Text } from 'evergreen-ui';
import './messages.css';
import SuspenseSpinner from 'Utils/SuspenseSpinner';
import { MessageHeader } from './types';

type MessageHeadersProps = {
  messageId: number,
  useGetMessageHeaders: any
}

export default function MessageHeaders({ messageId, useGetMessageHeaders }: MessageHeadersProps) {
  const { data: headers = [], isFetching } = useGetMessageHeaders(messageId);
  if (isFetching) return <SuspenseSpinner />;
  if (headers.length === 0) return <Strong>Нет заголовков</Strong>;
  return (
    <Pane className="message-headers-wrapper" border>
      <Pane className="message-header">
        {(headers as MessageHeader[]).map(({ id, name, value }) => (
          <div key={id} className="message-header-row">
            <Strong>{name}</Strong>
            <Text whiteSpace="break-spaces">{value}</Text>
          </div>
        ))}
      </Pane>
    </Pane>
  );
}
